import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import React, { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Child from '../Assets/Childrens.jpg';

function Children() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <Card>
                <Card.Img variant="top" src={Child} />
                <Card.Body>
                    <Card.Title>Childrens</Card.Title>
                    <Card.Text>
                        Children and Adolescents can suffer from behavioral and emotional problems which disrupts their well-being.
                    </Card.Text>
                    <Button style={{backgroundColor:"#6883BC",borderRadius: "0",border: "none"}} onClick={handleShow}>Know More</Button>
                </Card.Body>
            </Card>
            <Offcanvas show={show} onHide={handleClose} style={{ width: "-webkit-fill-available" }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>CHILDRENS/ADOLESCENTS THERAPY</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <p>Just as adults, children can suffer from psychological problems. These may be considered to
                        have simple behavioral, mental, emotional or learning difficulties to complex psychological
                        problems.Problems range from school refusal, difficulty with concentration and learning,
                        disruptive behavior, eating and sleeping problems.</p>
                    <p>
                        If you suspect that your child has some difficulty, you should consult a qualified mental health
                        professional who specializes in working with children and adolescents. They will conduct a
                        thorough evaluation to rule out any other possible causes.
                    </p>
                    <p>If the children are very young , it will include the parent, older children will meet the therapist
                        alone.Some types of therapy include working with the whole family and important adults in the
                        child's life. It is meant to treat a condition and help children to manage their disturbances so
                        they can function optimally.</p>
                    <p><b>Emotional disturbances & Behavioral changes there are two types of triggers for emotional problems in children:</b></p>
                    <p><b>Internal</b></p>
                    <p>These are linked to the emotional regulation of each human being.</p>
                    <p>Some factors that can determine a tendency to suffer emotional problems are: having an
                        excessively strong character, being highly introverted, or suffering attention deficits, insecurity
                        or failures in the processing of information.</p>
                    <p><b>External</b></p>
                    <p>The environment in which a child grows will greatly determine his/her development. If your
                        child is part of a family where there is violence, aggression and negativity, your emotional
                        stability will be impaired.</p>
                    <p>Also, the school environment is equally important, since it offers children their first contact
                        with peers in the outside world. Therefore, it’s important that there are no situations of abuse
                        or harassment. Other influences include bad relationships with teachers, not feeling like a
                        valued member of the classroom, and poor academic performance.</p>
                    <p><b>How Therapy can help</b></p>
                    <p>Before starting the therapy, the professional conducts a comprehensive evaluation of the
                        children's mental health to figure out what type of therapy might work best.</p>
                    <p>If the children are very young , it will include the parent, older children will meet the therapist
                        alone.Some types of therapy include working with the whole family and important adults in the
                        child's life. It is meant to treat a condition and help children to manage their disturbances so
                        they can function optimally.</p>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Children;